import styled from 'styled-components';
import { useRouter } from 'next/router';
import { useRef } from 'react';
import OnOutsideClick from '../../lib/Custom Hooks/onOutsideClick';
import ImageWrapper from '../ImageWrapper';

interface DynamicPopupsContainerProps {
  handleClose?: () => void;
  popups?: any;
}

const Popup = ({ handleClose, popups }: DynamicPopupsContainerProps) => {
  const router = useRouter();
  const { locale } = useRouter();
  const containerRef = useRef<HTMLDivElement>(null);

  OnOutsideClick(containerRef, containerRef, handleClose);

  const handleRedirect = () => {
    if (popups?.redirectUrl) {
      router.push(popups.redirectUrl);
    }
  };

  return (
    <Container locale={locale} id="dynamic-popup" onClick={handleRedirect}>
      <div className="content" id="dynamic-popup-modal" ref={containerRef}>
        <ImageWrapper
          src={locale == 'en' ? popups?.imageUrl : popups?.imageUrlAr}
          alt="webview-popup"
          fill
          style={{ zIndex: -1 }}
          imageSize="high"
        />

        <button className="close-btn" onClick={handleClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="31"
            viewBox="0 0 30 31"
            fill="none"
          >
            <path
              d="M8.81282 8.83333L21.1872 21.2077M21.1872 8.83333L8.81282 21.2077"
              stroke="#212427"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </Container>
  );
};

const Container = styled.div<{ locale?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: #000000bf;
  cursor: pointer;

  &.remove-overlay {
    background: transparent;
  }
  .content {
    position: relative;
    width: 923px;
    height: 617px;
    padding: 200px 58px 45px;
    transform: scale(1) translate(0, 0);
    opacity: 1;

    &.disappear {
      opacity: 0;
    }

    .close-btn {
      position: absolute;
      width: 40px;
      height: 40px;
      top: 32px;
      ${props => (props.locale === 'ar' ? 'left: 32px' : 'right: 32px')};
      cursor: pointer;
      border: none;
      outline: none;
      background-color: #fff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export default Popup;
